<template>
    <main class="main" id="main">
        <navigate></navigate>
        <section class="section s-lk">

            <div class="container">
                <div class="restaurants_box">
                    <div class="header">
                        <input type="text" name="datetimes" id="stats_range" class="range_input"/>
                        <button class="menu_item_btn green" @click="addRest">ДОБАВИТЬ РЕСТОРАН</button>
                    </div>
                    <table class="table" id="restaurant_table">
                        <div class="wrapper">
                            <div class="dataTables_length" id="restaurant_table_length"></div>
                        </div>
                        <thead>
                        <tr class="row">
                            <th>ID</th>
                            <th>Город</th>
                            <th>Название</th>
                            <th>E-mail</th>
                            <th>Телефон</th>
                            <th>Меню</th>
                            <th>Работает</th>
                            <th>Добавлен</th>
                            <th>Обновлён</th>
                            <th>Парсер</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="row" v-for="(restaurant, index) in restaurants" :key="index">
                            <td class="td">{{restaurant.id}}</td>
                            <td class="td">{{restaurant.city}}</td>
                            <td class="td">{{restaurant.name}}</td>
                            <td class="td">{{restaurant.email}}</td>
                            <td class="td">{{restaurant.phone}}</td>
                            <td class="td">{{restaurant.menu}}</td>
                            <td class="td">{{restaurant.is_working}}</td>
                            <td class="td">{{restaurant.created_at}}</td>
                            <td class="td">{{restaurant.updated_at}}</td>
                            <td class="td">
                                <button class="parser" v-if="restaurant.parser_site" @click="updateUrl(restaurant.parser_site)" style="background: blue">Сайт</button>
                                <button class="parser" v-if="restaurant.parser_delivery" @click="updateUrl(restaurant.parser_delivery)" style="background: blue">Delivery</button>
                                <button class="parser red" v-if="restaurant.delete_menu" @click="deleteMenu(restaurant.delete_menu)">Удалить меню</button>
                                <button class="parser yellow" v-if="restaurant.disable_menu" @click="disableMenu(restaurant.disable_menu)">Отключить меню</button>
                                <p v-if="restaurant.parser_time" style="font-size: 8px">{{restaurant.parser_time}}</p>
                            </td>
                            <td class="td">
                                <router-link tag="button" :to="'/lk/restaurant/' + restaurant.id" class="open_btn">Открыть</router-link>
                                <button class="open_btn" v-if="restaurant.delete" @click="deleteRestaurant(restaurant.id)" style="margin-top: 5px;background: red;font-size: 10px;padding: 3px 15px;">удалить</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

    </main>

</template>

<script>
import $ from 'jquery'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
import axios from '@/router/http'
import Navigate from '@/pages/lk/user/navigate'
import 'daterangepicker/daterangepicker'
import 'daterangepicker/daterangepicker.css'
import moment from 'moment'
export default {
  name: 'restaurants',
  components: {Navigate},
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      range: {},
      restaurants: []
    }
  },
  mounted () {
    $('#stats_range').daterangepicker({
      language: 'ru',
      alwaysShowCalendars: true,
      ranges: {
        'Сегодня': [moment(), moment()],
        'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'За последние 7 дней': [moment().subtract(6, 'days'), moment()],
        'За последние 30 дней': [moment().subtract(29, 'days'), moment()],
        'В этом месяце': [moment().startOf('month'), moment().endOf('month')],
        'В прошлом месяце': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      'locale': {
        'format': 'MM/DD/YYYY',
        'separator': ' - ',
        'applyLabel': 'Принять',
        'cancelLabel': 'Отменить',
        'fromLabel': 'От',
        'toLabel': 'До',
        'customRangeLabel': '',
        'weekLabel': 'Н',
        'daysOfWeek': [
          'Вс',
          'Пн',
          'Вт',
          'Ср',
          'Чт',
          'Пт',
          'Сб'
        ],
        'monthNames': [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь'
        ],
        'firstDay': 1
      }
    }, (start, end, label) => {
      this.range = {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }
      this.currentCity = null
    })
  },
  methods: {
    updateUrl (url) {
      setTimeout(() => { alert('Парсер начал работу в фоне, можете продолжать работу') }, 1)
      axios.get(url).then(response => {
        alert('Парсер завершил работу')
      })
    },
    deleteMenu (url) {
      if (confirm('Вы действительно хотите удалить все меню ресторана, действие не обратимо?')) {
        axios.get(url).then(response => {
          alert('Меню очищено')
        })
      }
    },
    disableMenu (url) {
      if (confirm('Вы действительно хотите отключить все меню ресторана, для включения придется вручную включать каждую позицию?')) {
        axios.get(url).then(response => {
          alert('Меню выключено')
        })
      }
    },
    deleteRestaurant (id) {
      if (confirm('Вы действительно хотите удалить ресторан? ОТМЕНИТЬ УДАЛЕНИЕ НЕВОЗМОЖНО!')) {
        var formData = new FormData()
        formData.append('uid', this.auth.uid)
        formData.append('id', id)
        axios.post('https://lk.when-hungry.com/mobile/delete-restaurant',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          alert('Ресторан удален')
        })
      }
    },
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/get-restaurants?uid=' + this.auth.uid).then(response => {
        this.restaurants = response.data
      })
    },
    addRest () {
      var formData = new FormData()
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/new-restaurants',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          window.location.href = '/lk/restaurant/' + response.data.id
        }
      })
    }
  },
  watch: {
    restaurants () {
      if ($('#restaurant_table.dataTable').length) $('#restaurant_table').DataTable().destroy()
      setTimeout(() => {
        $('#restaurant_table').DataTable({
          'order': [[0, 'desc']],
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          },
          'scrollX': true
        })
      }, 300)
    },
    range () {
      if (this.range.start && !this.range.end) {
        axios.get('https://lk.when-hungry.com/mobile/get-restaurants?uid=' + this.auth.uid + '&date=' + this.range.start).then(response => {
          this.restaurants = {}
          this.restaurants = response.data
        })
      } else {
        if (this.range.start && this.range.end) {
          axios.get('https://lk.when-hungry.com/mobile/get-restaurants?uid=' + this.auth.uid + '&start=' + this.range.start + '&end=' + this.range.end).then(response => {
            this.restaurants = {}
            this.restaurants = response.data
          })
        }
      }
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurants.vue